// extracted by mini-css-extract-plugin
module.exports = {"authButtonWrapper":"styles_authButtonWrapper__ywerJ"};